import React from "react";

import { isEmpty } from "lodash/fp";

import { Box, Skeleton, Typography } from "@mui/material";

import PulseGraphic from "@app/analytics/assets/PulseGraphic.png";
import { SummaryModule } from "@app/analytics/Pulse/components/styles";

import Stack, { Row } from "@rui/Stack";

const Summary = ({
  content,
  details,
  loading = false,
  thumbnail,
  title,
  subtitle,
}: {
  title?: string;
  subtitle?: string;
  content?: string;
  details?: React.ReactNode;
  loading?: boolean;
  thumbnail: {
    src?: string;
    height?: number;
  };
}) => {
  if (loading) {
    return (
      <SummaryModule variant="apart" spacing={1.5}>
        <Stack spacing={2} flex={1}>
          <Stack spacing={0.25}>
            {title && (
              <Typography variant="h2" color="shades.primary.500">
                {title}
              </Typography>
            )}
            <Typography variant="bodySecondaryMed" color="shades.neutral.600">
              Here's what happened
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </Stack>
        </Stack>
      </SummaryModule>
    );
  }

  if (isEmpty(content)) return null;

  return (
    <SummaryModule variant="apart" spacing={1.5}>
      <Stack spacing={1}>
        {title && (
          <Row variant="apart" spacing={2} minHeight="32px">
            <Typography variant="h2" color="shades.primary.500">
              {title}
            </Typography>
            {details ?? null}
          </Row>
        )}
        <Row variant="apart" spacing={2}>
          <Stack spacing={1}>
            {subtitle && (
              <Typography variant="bodySecondaryMed" color="shades.neutral.600">
                {subtitle}
              </Typography>
            )}
            <Typography variant="bodySecondaryReg" color="shades.neutral.800">
              {content}
            </Typography>
          </Stack>
          <Box
            component="img"
            src={thumbnail.src ?? PulseGraphic}
            height={thumbnail.height ?? 112}
            sx={{ borderRadius: "4px" }}
          />
        </Row>
      </Stack>
    </SummaryModule>
  );
};

export default Summary;
